var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavbarUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 175,
  height: 3,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.778.183 0 1.583l6.746 1.31L26.1 2.883l15.578-.136 15.577.23 15.578-.248L88.412 3l15.577-.136h15.619l15.578-.035 15.619.141 22.428-.153L175 1.506 168.551.26 152.172.242 137.92.248 123.668.159h-14.252L95.165.06 80.913.03 66.66.025 52.409.295 38.157.065 23.905.213 9.612 0z"
})));
export default SvgNavbarUnderline;